import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { routerActions } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Header, Form, Grid, Button, Message, Confirm, Icon, Dropdown } from 'semantic-ui-react'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { Map, Marker } from '../../components/Map'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import * as FacilityStore from '../../store/Facility'
import * as Staff from '../../store/Staff'

function toGeocode(address, city, state, zip) {
    return [address, city, state, zip].join(', ').replace(/ /g, '+')
}
class Facility extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            clearanceFeet: 0,
            clearanceInches: 0,
            isLot: false,
            lat: 0,
            lng: 0,
            copied: false,
            workdayCode: null,
            alternateManagerName: null,
            alternateManagerEmail: null,
            alternateManagerPhone: null,
            managerId: null,
            owner: null,
            editorState: EditorState.createEmpty(),
            error: null,
            showDeleteConfirmation: false,
        }
        this.onEditorStateChange = this.onEditorStateChange.bind(this)
        this.isCreate = this.isCreate.bind(this)
        this.onAddressChange = this.onAddressChange.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onSave = this.onSave.bind(this)
        this.getFacility = this.getFacility.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onCancelDelete = this.onCancelDelete.bind(this)
        this.onConfirmDelete = this.onConfirmDelete.bind(this)
    }

    isCreate() {
        const { facilityId } = this.props
        return facilityId.toLowerCase() === 'add'
    }

    async onSave(e) {
        const { facilityId, actions } = this.props
        const {
            name,
            address,
            city,
            state,
            zip,
            clearanceFeet,
            clearanceInches,
            isLot,
            lat,
            lng,
            editorState,
            managerId,
            owner,
            alternateManagerName,
            alternateManagerEmail,
            alternateManagerPhone,
            workdayCode,
            tagColor,
        } = this.state
        try {
            const newFacility = {
                managerId,
                owner,
                alternateManagerName,
                alternateManagerEmail,
                alternateManagerPhone,
                name,
                workdayCode,
                address,
                city,
                state,
                zip,
                clearanceFeet,
                clearanceInches,
                isLot,
                lat,
                lng,
                tagColor,
                directions: draftToHtml(convertToRaw(editorState.getCurrentContent())),
            }
            if (this.isCreate()) {
                await actions.createFacility(newFacility)
            } else {
                await actions.updateFacility({ id: facilityId, ...newFacility })
            }
            actions.replace('/admin')
        } catch (error) {
            this.setState({ error: error.message })
        }
    }

    onChange(e, { name, value, type, checked }) {
        if (type === 'checkbox') {
            this.setState({ [name]: checked })
        } else {
            this.setState({ [name]: value })
        }
    }

    onEditorStateChange(editorState) {
        this.setState({ editorState })
    }

    async onAddressChange(e) {
        const { address, city, state, zip } = this.state
        const urlAddress = `/api/geo?address=${toGeocode(address, city, state, zip)}`
        const response = await fetch(urlAddress)
        const geoResult = await response.json()
        if (geoResult.status === 'OK') {
            console.log(geoResult)
            const { geometry } = geoResult.results[0]
            this.setState({ ...geometry.location })
        }
    }

    async onDelete(e) {
        e.preventDefault()
        const { facilityId, actions } = this.props
        try {
            await actions.deleteFacility({ id: facilityId })
            actions.replace('/admin')
            this.setState({ showDeleteConfirmation: false })
        } catch (error) {
            this.setState({ error: error.message, showDeleteConfirmation: false })
            window.scrollTo(0, 0)
        }
    }

    onConfirmDelete(e) {
        e.preventDefault()
        this.setState({ showDeleteConfirmation: true })
    }

    onCancelDelete(e) {
        e.preventDefault()
        this.setState({ showDeleteConfirmation: false })
    }

    getFacility() {
        if (this.isCreate()) {
            return this.state
        } else {
            const { copied } = this.state
            if (!copied) {
                const { facility, facilityId } = this.props
                const f = { ...facility.facilities[facilityId] }
                f.lat = parseFloat(f.lat)
                f.lng = parseFloat(f.lng)
                let editorState = EditorState.createEmpty()
                const contentBlock = htmlToDraft(f.directions)
                if (contentBlock) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
                    editorState = EditorState.createWithContent(contentState)
                }
                setTimeout(() => this.setState({ ...f, copied: true, editorState }), 200)
                return f
            }
            return this.state
        }
    }

    render() {
        const clearnceOptions = [
            { text: '0', value: 0 },
            { text: '1', value: 1 },
            { text: '2', value: 2 },
            { text: '3', value: 3 },
            { text: '4', value: 4 },
            { text: '5', value: 5 },
            { text: '6', value: 6 },
            { text: '7', value: 7 },
            { text: '8', value: 8 },
            { text: '9', value: 9 },
            { text: '10', value: 10 },
            { text: '11', value: 11 },
            { text: '12', value: 12 },
        ]
        const colorOptions = [
            {
                key: 'red',
                value: 'red',
                text: 'Red',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="red" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Red" />
                    </div>
                ),
            },
            {
                key: 'orange',
                value: 'orange',
                text: 'Orange',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="orange" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Orange" />
                    </div>
                ),
            },
            {
                key: 'yellow',
                value: 'yellow',
                text: 'Yellow',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="yellow" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Yellow" />
                    </div>
                ),
            },
            {
                key: 'green',
                value: 'green',
                text: 'Green',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="green" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Green" />
                    </div>
                ),
            },
            {
                key: 'blue',
                value: 'blue',
                text: 'Blue',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="blue" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Blue" />
                    </div>
                ),
            },
            {
                key: 'purple',
                value: 'purple',
                text: 'Purple',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="purple" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Purple" />
                    </div>
                ),
            },
            {
                key: 'brown',
                value: 'brown',
                text: 'Brown',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="brown" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Brown" />
                    </div>
                ),
            },
            {
                key: 'grey',
                value: 'grey',
                text: 'Grey',
                content: (
                    <div style={{ display: 'flex' }}>
                        <Icon style={{ margin: 2.5 }} name="stop" color="grey" />
                        <Header style={{ margin: 0, lineHeight: '1em' }} content="Grey" />
                    </div>
                ),
            },
        ]
        const f = this.getFacility()
        const { staff } = this.props
        const { error, showDeleteConfirmation } = this.state
        const {
            lat,
            lng,
            name,
            address,
            city,
            state,
            zip,
            clearanceFeet,
            clearanceInches,
            editorState,
            owner,
            alternateManagerName,
            alternateManagerEmail,
            alternateManagerPhone,
            managerId,
            tagColor,
            workdayCode,
        } = f
        const location = { lat, lng }
        console.log(f)
        return (
            <div className="facility">
                <Grid>
                    <Grid.Row>
                        <Grid.Column computer={8} tablet={16} mobile={16}>
                            <Confirm
                                header="Delete Facility"
                                confirmButton="Delete"
                                open={showDeleteConfirmation}
                                onCancel={this.onCancelDelete}
                                onConfirm={this.onDelete}
                                content="Are you sure you want to delete this Facility?"
                            />
                            <Header as="h1" content={`${this.isCreate() ? 'Add' : 'Edit'} Facility`} />
                            <Form error>
                                {error ? <Message error content={error} /> : error}
                                <Form.Input name="name" label="Facility Name" placeholder="Facility Name" value={name} onChange={this.onChange} />
                                <Form.Input name="workdayCode" label="Workday Code" placeholder="Workday Code" value={workdayCode} onChange={this.onChange} />
                                <Form.Input name="address" label="Address" placeholder="Address" value={address} onChange={this.onChange} onBlur={this.onAddressChange} />
                                <Form.Group>
                                    <Form.Input width={11} name="city" label="City" placeholder="City" value={city} onChange={this.onChange} onBlur={this.onAddressChange} />
                                    <Form.Input
                                        width={3}
                                        name="state"
                                        label="State"
                                        placeholder="State"
                                        value={state}
                                        maxLength="2"
                                        onChange={this.onChange}
                                        onBlur={this.onAddressChange}
                                    />
                                    <Form.Input width={4} name="zip" label="Zip Code" placeholder="Zip Code" value={zip} onChange={this.onChange} onBlur={this.onAddressChange} />
                                </Form.Group>
                                <Form.Group inline>
                                    <Form.Select fluid name="clearanceFeet" label="Clearance Ft" options={clearnceOptions} value={clearanceFeet} onChange={this.onChange} />
                                    <Form.Select
                                        fluid
                                        name="clearanceInches"
                                        label="Clearance Inch"
                                        options={clearnceOptions.slice(0, -1)}
                                        value={clearanceInches}
                                        onChange={this.onChange}
                                    />
                                    <Form.Field>
                                        <label></label>
                                        <Form.Checkbox name="isLot" label="Is Lot?" onChange={this.onChange} />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Select
                                    name="managerId"
                                    label="Facility Manager"
                                    placeholder="Facility Manager"
                                    value={managerId}
                                    options={Object.values(staff).map((s, index) => ({ text: `${s.firstName} ${s.lastName}`, value: s.id }))}
                                    onChange={this.onChange}
                                />
                                <Form.Input name="owner" label="Owner" placeholder="Owner" value={owner} onChange={this.onChange} />
                                <Form.Input
                                    name="alternateManagerName"
                                    label="Alternate Manager Name"
                                    placeholder="Alternate Manager Name"
                                    value={alternateManagerName}
                                    onChange={this.onChange}
                                />
                                <Form.Input
                                    name="alternateManagerEmail"
                                    label="Alternate Manager Email"
                                    placeholder="Alternate Manager Email"
                                    value={alternateManagerEmail}
                                    onChange={this.onChange}
                                />
                                <Form.Input
                                    name="alternateManagerPhone"
                                    label="Alternate Manager Phone"
                                    placeholder="Alternate Manager Phone"
                                    value={alternateManagerPhone}
                                    onChange={this.onChange}
                                />
                            </Form>
                            <Form.Field>
                                <label>Hang Tag Color</label>
                                <Dropdown name="tagColor" fluid selection onChange={this.onChange} value={tagColor} options={colorOptions} />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column computer={8} tablet={16} mobile={16}>
                            <Header as="h5" content="Driving Directions to Entrance" />
                            <Editor wrapperClassName="wsywig-wrapper" editorClassName="wsywig-editor" onEditorStateChange={this.onEditorStateChange} editorState={editorState} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Button primary content="Save" onClick={this.onSave} />
                        {!this.isCreate() ? <Button negative floated="right" content="Delete Facility" type="button" onClick={this.onConfirmDelete} /> : null}
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Map {...(location ? { center: location } : {})}>
                                {location ? <Marker position={location} title={name} address={`${address}, ${city}, ${state} ${zip}`} /> : null}
                            </Map>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

Facility.propTypes = {
    facilityId: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
    return {
        facilityId: ownProps.match.params.facilityId,
        facility: FacilityStore.selector(state),
        staff: Staff.selector(state).staff,
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(FacilityStore.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Facility)
)
